import React, { useState } from 'react'
import { Dialog, DialogPanel, DialogBackdrop, DialogTitle, Transition } from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faSpinner, faXmarkCircle } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'

const ReferralModal = ({ openReferral, setOpenReferral }) => {
  const [schoolName, setSchoolName] = useState('')
  const [schoolPostcode, setSchoolPostcode] = useState('')
  const [contactName, setContactName] = useState('')
  const [contactEmail, setContactEmail] = useState('')
  const [positionHeld, setPositionHeld] = useState('')
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showThanks, setShowThanks] = useState(false)

  const handleClose = () => {
    setShowThanks(false)
    setOpenReferral(false)
  }

  const resetInputs = () => {
    setSchoolName('')
    setSchoolPostcode('')
    setContactName('')
    setContactEmail('')
    setPositionHeld('')
  }

  const submitForm = async () => {
    setLoading(true)
    setFormSubmitted(true)

    const params = {
      contact_id: window.Policy.user.id,
      org_type: window.Policy.orgType,
      referrable_id: window.Policy.cid,
      company_id: 0,
      details: {
        school_name: schoolName,
        school_postcode: schoolPostcode,
        contact_name: contactName,
        contact_email: contactEmail,
        contact_position: positionHeld,
        referrer_school_name: window.Policy.orgName
      }
    }

    try {
      await axios.post('api/referral/create', params)
      setLoading(false)
      setFormSubmitted(false)
      setShowThanks(true)
      resetInputs()
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  return (
    <Transition show={openReferral} as={React.Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <DialogBackdrop className="fixed inset-0 bg-black bg-opacity-30" />

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <DialogPanel className="w-full max-w-xl rounded-xl bg-white shadow-xl p-6 overflow-hidden">
            {/* Header */}
            <div className="flex items-start justify-between mb-4">
              <DialogTitle className="text-lg font-semibold text-gray-800 text-center w-full">
                Exclusive Refer A School Offer for SAS Customers
              </DialogTitle>
              <button className="text-gray-500 hover:text-gray-700" onClick={handleClose}>
                <FontAwesomeIcon icon={faXmarkCircle} className="h-5 w-5" />
              </button>
            </div>

            {/* Body */}
            {!formSubmitted && !showThanks && (
              <>
                <p className="text-sm text-center mb-4">
                  <strong>
                    If you refer another school to us, we will give your school a digital voucher of your
                    choosing for £100! See full terms and conditions on our website at{' '}
                    <a
                      href="https://schooladvice.co.uk/refer-a-school"
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noreferrer"
                    >
                      schooladvice.co.uk/refer-a-school
                    </a>
                  </strong>
                </p>

                <p className="mb-4">Please enter the details of the school/academy you are referring.</p>

                <form onSubmit={(e) => { e.preventDefault(); submitForm() }} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium">School Name</label>
                    <input type="text" className="w-full border rounded p-2" value={schoolName} onChange={e => setSchoolName(e.target.value)} required />
                  </div>

                  <div>
                    <label className="block text-sm font-medium">Postcode</label>
                    <input type="text" className="w-full border rounded p-2" value={schoolPostcode} onChange={e => setSchoolPostcode(e.target.value)} required />
                  </div>

                  <div>
                    <label className="block text-sm font-medium">Contact Name</label>
                    <input type="text" className="w-full border rounded p-2" value={contactName} onChange={e => setContactName(e.target.value)} required />
                  </div>

                  <div>
                    <label className="block text-sm font-medium">Contact Email</label>
                    <input type="email" className="w-full border rounded p-2" value={contactEmail} onChange={e => setContactEmail(e.target.value)} required />
                  </div>

                  <div>
                    <label className="block text-sm font-medium">Position Held</label>
                    <input type="text" className="w-full border rounded p-2" value={positionHeld} onChange={e => setPositionHeld(e.target.value)} required />
                  </div>

                  <div className="text-center pt-2">
                    <button
                      type="submit"
                      className="w-64 py-2 bg-sas text-white font-semibold rounded hover:bg-sas-dark transition"
                    >
                      Send Referral
                    </button>
                  </div>
                </form>
              </>
            )}

            {/* Loading */}
            {loading && (
              <div className="text-center py-8">
                <p className="mb-4">Sending Referral...</p>
                <FontAwesomeIcon icon={faSpinner} spin className="text-sas text-4xl" />
              </div>
            )}

            {/* Thanks */}
            {!formSubmitted && !loading && showThanks && (
              <div className="text-center py-6">
                <strong>
                  <p className="text-lg mb-6">Thank you for your referral!</p>
                </strong>
                <button
                  className="px-6 py-2 bg-sas text-white rounded hover:bg-sas-dark"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            )}
          </DialogPanel>
        </div>
      </Dialog>
    </Transition>
  )
}

export default ReferralModal